import React, { PureComponent } from 'react';
import { arrayOf, object, string, func, bool } from 'prop-types';
import compose from 'lodash/flowRight';
import { connectRefinementList } from 'react-instantsearch-core';
import { withColorFamilies } from 'connectors';
import { colorFamiliesShape } from 'shapes';
import FilterCollapsePanel from '../FilterCollapsePanel/FilterCollapsePanel';
import CommonColorList from './CommonColorList/CommonColorList';

class ColorList extends PureComponent {
    static propTypes = {
        className: string,
        items: arrayOf(object).isRequired,
        label: string.isRequired,
        currentRefinement: arrayOf(string).isRequired,
        refine: func.isRequired,
        style: object, // eslint-disable-line react/forbid-prop-types
        attribute: string.isRequired,
        openedByDefault: bool,
        onFilterSelected: func.isRequired,
        colorFamilies: colorFamiliesShape.isRequired,
    };

    static defaultProps = {
        className: null,
        openedByDefault: true,
        style: {},
    };

    doRefine = value => {
        const { currentRefinement, refine, onFilterSelected } = this.props;

        const valueIndex = currentRefinement.indexOf(value);
        let values = [...currentRefinement];
        if (valueIndex === -1) {
            values.push(value);
            onFilterSelected({ value });
        } else {
            values = values.filter(val => val !== value);
        }
        refine(values);
    };

    render() {
        const {
            style,
            className,
            label,
            currentRefinement,
            attribute,
            openedByDefault,
            colorFamilies,
            ...otherProps
        } = this.props;
        return (
            <FilterCollapsePanel
                className={className}
                label={label}
                dataQa={attribute}
                openedByDefault={openedByDefault}
            >
                <CommonColorList
                    label={label}
                    attribute={attribute}
                    onClick={this.doRefine}
                    colorFamilies={colorFamilies}
                    {...otherProps}
                />
            </FilterCollapsePanel>
        );
    }
}

export default compose(
    connectRefinementList,
    withColorFamilies,
)(ColorList);
